// instructor-profile
export const COURSE_BY_INSTRUCTOR = 'course-by-instructor';
export const REGULAR_CLASS_BY_INSTRUCTOR = 'regular-class-by-instructor';
export const INSTRUCTOR_PROFILE = 'instructor-profile';
export const MY_LEARNING = 'my-learning';
